export const BUILD_VERSION = '1793040003';
